import styled, { css } from "styled-components";

export const Box = styled.div<{ padding: number | string | undefined }>`
  border: 1px solid #d2d2d2;
  border-radius: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: ${(props) => (props.padding ? props.padding : "24px")};
  background-color: white;
`;

export const SubHeader = styled.h2`
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  text-transform: uppercase;
  line-height: 16px;
  margin-bottom: 7px;
`;

export const Input = styled.input`
  width: 100%;
  min-height: 38px;
  padding-left: 10px;
  color: black;
  background: white;
  font-size: 14px;
  border-radius: 0;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  border-color: hsl(0, 0%, 80%);
  border: 0px solid;
  outline: none;

  &:hover: {
    border-color: #babcba;
  }

  &::placeholder {
    color: #babcba;
    font-size: 14px;
    white-space: nowrap;
  }
`;

export const TitleExplanation = styled.div`
  color: #8e8e8e;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 12px;
  strong {
    color: #8e8e8e;
    font-weight: 700;
  }
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  gap: 5px;
`;

export const TooltipText = styled.p`
  font-size: 12px;
  text-transform: none;
  font-weight: 400;
`;

export const VolumeTag = styled.div(
  ({ primary, shadow }: any) => `
      background: ${primary ? "green" : "#F1FDEF"};
      border-radius: 100px;
      border: 1px solid #48E231;
      box-shadow: ${shadow ? "2px 2px 2px rgba(0, 0, 0, 0.5)" : "none"};
      color: #000000;
      font-weight: 600;
      line-height: 14.5px;
      width: fit-content;
      padding: 0px 8px;
      font-size: 12px;
    `,
);

export const PercentageTag = styled.div(
  ({ shadow }: any) => `
      background-color: #FFF8DD;
      border-radius: 100px;
      border: 1px solid #FFDD55;
      box-shadow: ${shadow ? "2px 2px 2px rgba(0, 0, 0, 0.5)" : "none"};
      color: #000000;
      font-weight: 600;
      line-height: 14.5px;
      width: fit-content;
      padding: 0px 8px;
      font-size: 12px;
    `,
);

export const Subtitle = styled.h3`
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 39px;
  margin-bottom: 10px;
`;

export const Title = styled.h1`
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
`;

export const ColorDiv = styled.div`
  width: 27px;
  margin-bottom: 8px;
  height: 5px;
`;

export const DashboardAnalyticsNavContainer = styled.div`
  display: flex;
  margin-top: 40px;
  margin-bottom: 20px;
`;

export const DashboardAnalyticsNavItem = styled.div<{ isActive: boolean }>`
  font-weight: 700;
  font-size: 12px;
  line-height: 40px;
  margin-right: 25px;
  width: 120px;
  display: flex;
  justify-content: center;
  ${(props) =>
    props.isActive &&
    css`
      a {
        color: #000000;
      }
      border-bottom: 6px solid #0d0d0d;
    `}
`;
